import { render, staticRenderFns } from "./MeetingStatusPill.vue?vue&type=template&id=0524f971&scoped=true"
import script from "./MeetingStatusPill.vue?vue&type=script&lang=js"
export * from "./MeetingStatusPill.vue?vue&type=script&lang=js"
import style0 from "./MeetingStatusPill.vue?vue&type=style&index=0&id=0524f971&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0524f971",
  null
  
)

export default component.exports